import React, {  useEffect, useState } from 'react';
import {  Button,  } from 'antd';
import { Col, Row } from 'react-bootstrap';
import Card from '../../../components/bootstrap/card';
import {  tradeScrip } from '../../../services/RodtepReportService';
import { Form } from 'react-bootstrap';
import { Modal } from 'antd';
import isEmpty from 'lodash/isEmpty'

const SellScrip = (props) => {
    const [formValues, setFormValues] = useState({
      trading_details: '',
      balance_amt: '',
      rate: '',
      scrip_number: '',
      scrip_issue_date: '',
      scrip_expiry_date: '',
      scrip_issue_amount: 0,  
    });

    useEffect(() => {
      if (props.data) {
          setFormValues(props.data);
      }
  }, [props.data, props.title, props.open]);


  
    const handleInputChange = (e) => {
      const { name, value, type } = e.target;
      console.log('on change ', {name, value, type })

      if (name === 'scrip_issue_amount' || name === 'balance_amt' || name === 'rate') {
        setFormValues({
          ...formValues,
          [name]: parseFloat(value),
        });
      }else if( type === 'date') {
        setFormValues({
          ...formValues,
          [name]: formatDateTime(value),
        });
      }
      else{
        setFormValues({
          ...formValues,
          [name]: value,
        });
      }
  
    }
  
    const closeModal = () => {
      setFormValues({
        trading_details: '',
        balance_amt: '',
        rate: '',
      scrip_number: '',
      scrip_issue_date: '',
      scrip_expiry_date: '',
      scrip_issue_amount: 0,  
  
      });
      props?.handleClose && props?.handleClose();
  
    };
  
    function validateScripObject(scrip) {
      console.log('scrip ', scrip)
      const errors = {};
  
      if (isEmpty(scrip.scrip_number)) {
          errors.scrip_number = "Scrip number is required.";
      }
      if (isEmpty(scrip.scrip_issue_date)) {
          errors.scrip_issue_date = "Scrip issue date is required.";
      }
      if (isEmpty(scrip.scrip_expiry_date)) {
          errors.scrip_expiry_date = "Scrip expiry date is required.";
      }
      if (isEmpty(scrip.trading_details)) {
        errors.scrip_expiry_date = "Trading Details is required.";
      }
  
      if (scrip.scrip_issue_date && scrip.scrip_expiry_date) {
          const issueDate = new Date(scrip.scrip_issue_date);
          const expiryDate = new Date(scrip.scrip_expiry_date);
  
          if (isNaN(issueDate.getTime())) {
              errors.scrip_issue_date = "Invalid issue date format.";
          }
          if (isNaN(expiryDate.getTime())) {
              errors.scrip_expiry_date = "Invalid expiry date format.";
          }
          if (!errors.scrip_issue_date && !errors.scrip_expiry_date && expiryDate <= issueDate) {
              errors.scrip_expiry_date = "Scrip expiry date must be greater than the issue date.";
          }
      }
  
      if (typeof scrip.scrip_issue_amount !== "number" || scrip.scrip_issue_amount < 0) {
          errors.scrip_issue_amount = "Scrip issue amount must be a non-negative number.";
      }
     

      if (typeof scrip.balance_amt !== "number" || scrip.balance_amt < 0) {
        errors.balance_amt = "Scrip value must be a non-negative number.";
      }

      if (typeof scrip.balance_amt !== "number" || scrip.balance_amt > props.data.balance_amt) {
        errors.balance_amt = "Scrip value must be a less than "+props.data.balance_amt;
      }

      if (typeof scrip.rate !== "number") {
        errors.rate = "Rate value must be a number";
      }
      
      if (scrip.rate > 100) {
        errors.rate = "Rate value must be less than or equals to 100";
      }
  
      return Object.keys(errors).length === 0 ? null : errors;
  }
  
  
  
    const onSubmit = async () => {
  
      try {
        const errors = validateScripObject(formValues)
        if (!isEmpty(errors)) {
          throw new Error(Object.values(errors).join(','))
        }
        const formData = { ...formValues,  value: formValues.balance_amt, trading_details: formValues.trading_details ?? '',  trading_type: 'SOLD' }
        // Append any additional data or files if needed
        // Make the API call
        await tradeScrip(formData)
        closeModal()
        props.onSuccessFunction(`Scrip balance: ${formData.value}, sold successfully for scrip_number: ${formData.scrip_number}!`)
  
      }
      catch (error) {
        errorFunction(error?.message ? error?.message : error);
      }
  
    };
  
    const errorFunction = (content) => {
      if (props?.errorFunction) {
        props.errorFunction(content)
      }
    };
  
  
    const formatDateTime = (dateTimeStr) => {
      const date = new Date(dateTimeStr);
      if (isNaN(date.getTime())) {
          return null;
      }
      return date.toISOString().split('T')[0];
  }
  
  
  
    return (
      <div id="test-modal">
        <Modal
          title={props.title}
          width={"60%"}
          open={props.open}
          onCancel={closeModal}
          footer={[
            <Button key="submit" type="primary" className="cip-btn-submit" onClick={onSubmit}>
              Submit
            </Button>
          ]}
        >
          <Card>
            <Card.Body>
              <hr className="hr-horizontal" />
              <Form>
                <Form.Group as={Row} className="mb-3" controlId="scrip_number">
                  <Form.Label column sm="2">Scrip Number*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="text"
                      name="scrip_number"
                      placeholder='Enter Scrip Number'
                      value={formValues.scrip_number}
                      disabled={true}
                    />
                  </Col>
                  <Form.Label column sm="2">Trading Details*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      name="trading_details"
                      placeholder='Enter Trading Details'
                      value={formValues.trading_details}
                      onChange={handleInputChange}
                      type="text"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="scrip_issue_date">
                  <Form.Label column sm="2">Scrip Issue Date*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="date"
                      name="scrip_issue_date"
                      placeholder='Enter Scrip Issue Date'
                      value={formValues.scrip_issue_date}
                      disabled={true}

                    />
                  </Col>
                  <Form.Label column sm="2">Scrip Expiry Date*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="date"
                      name="scrip_expiry_date"
                      defaultValue={formValues.scrip_issue_date}
                      placeholder='Enter Scrip Expiry Date'
                      value={formValues.scrip_expiry_date}
                      disabled={true}

                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="scrip_issue_amount">
                  <Form.Label column sm="2">Scrip Issue Amount*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="scrip_issue_amount"
                      placeholder='Enter Scrip Issue Amount'
                      value={formValues.scrip_issue_amount}
                      disabled={true}

                    />
                  </Col>
                  <Form.Label column sm="2">Value*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="balance_amt"
                      placeholder='Enter Value'
                      min={0}
                      max={parseFloat(formValues.balance_amt)}
                      value={formValues.balance_amt}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Form.Group>  
                <Form.Group as={Row} className="mb-3" controlId="rate">
                  <Form.Label column sm="2">Rate*</Form.Label>
                  <Col sm="4">
                    <Form.Control
                      required
                      type="number"
                      name="rate"
                      placeholder='Enter Rate'
                      value={formValues.rate}
                      onChange={handleInputChange}
                    />
                  </Col>
                  
                </Form.Group> 
              </Form>
            </Card.Body>
          </Card>
        </Modal>
      </div>
    )
  }

  export default SellScrip